module.exports = __webpack_public_path__ + "static/media/TheLisa_2751PrairieDr.d5384069.jpg";